import React from 'react';
import PropTypes from 'prop-types';
import { Box, Alert, Button, Typography } from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';

/**
 * Component to display error state
 * @param {Object} props - Component props
 * @param {Object} props.error - Error object
 * @param {Function} props.onRetry - Function to retry the operation
 * @returns {React.ReactElement} Error view component
 */
const ErrorView = ({ error, onRetry }) => {
  return (
    <Box sx={{ width: '100%', mb: 3 }}>
      <Alert 
        severity="error" 
        sx={{ 
          borderRadius: 1, 
          '& .MuiAlert-message': { 
            display: 'flex', 
            alignItems: 'center',
            flex: 1
          }
        }}
        action={
          <Button 
            variant="outlined" 
            color="error" 
            size="small" 
            startIcon={<RefreshIcon />}
            onClick={onRetry}
          >
            Retry
          </Button>
        }
      >
        <Typography variant="body2">
          Failed to load tasks: {error?.message || 'Unknown error'}
        </Typography>
      </Alert>
    </Box>
  );
};

ErrorView.propTypes = {
  error: PropTypes.object,
  onRetry: PropTypes.func.isRequired
};

export default React.memo(ErrorView);